import "./Pricing.module.css";
import Navigation from "@/reusable_sections/Header";
import Inquiry from "./sections/Inquiry";
import Process from "./sections/Process";
import Questions from "./sections/Questions";
import Footer from "@/reusable_sections/Footer";
export default function PricingPage() {
  return <div>
      <Navigation />
      <Inquiry />
      <Process />
      <Questions />
      <Footer />
    </div>;
}